import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import SymbolAvgVoltage from './SymbolAvgVoltage';
import "./Svg.css";


function SvgPv({x, y, Combinations }) {
    const { t } = useTranslation();

    const [count, setCount] = useState(0);
    const [PPV1, setPPV1] = useState(0);  //PV1总直流功率
    const [PPV2, setPPV2] = useState(0);  //PV2总直流功率
    const [VPV1, setVPV1] = useState(0);  //PV1电压
    const [VPV2, setVPV2] = useState(0);  //PV2电压
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (Combinations != null) {
            let rs = [];
            let p1 = 0;
            let p2 = 0;
            let v1 = 0;
            let v2 = 0;
            Combinations.forEach((item, index) => {
                if (item.PPV1 != null && item.PPV1 > 0) {
                    p1 += parseInt(item.PPV1) * 0.001;
                }
                if (item.PPV2 != null && item.PPV2 > 0) {
                    p2 += parseInt(item.PPV2) * 0.001;
                }
                if (item.VPV1 != null && item.VPV1 > 0) {
                    let t2 = parseInt(item.VPV1) * 0.1;
                    v1 += t2;
                }
                if (item.VPV2 != null && item.VPV2 > 0) {
                    let t2 = parseInt(item.VPV2) * 0.1;
                    v2 += t2;
                }
                rs.push({
                    SN: item.SN,
                    CreateTime: item.CreateTime,
                    Phase: item.InverterConnectionMode,
                    PPV1: item.PPV1 != null ? (parseInt(item.PPV1) * 0.001).toFixed(3) : "",
                    PPV2: item.PPV2 != null ? (parseInt(item.PPV2) * 0.001).toFixed(3) : "",
                    VPV1: item.VPV1 != null ? (parseInt(item.VPV1) * 0.1).toFixed(1) : "",
                    VPV2: item.VPV2 != null ? (parseInt(item.VPV2) * 0.1).toFixed(1) : "",
                });
            });
            if (Combinations.length > 0) {
                v1 = v1 / Combinations.length;
                v2 = v2 / Combinations.length;
            }
            setPPV1(p1.toFixed(3));
            setPPV2(p2.toFixed(3));
            setVPV1(v1.toFixed(1));
            setVPV2(v2.toFixed(1));
            setRows(rs);
            setCount(Combinations.length);
        }
    }, [Combinations]);

    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "70%",
            icon: null,
            title: t("PVs Data"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase === 2 ? "(A)" : r.Phase === 3 ? "(B)" : r.Phase === 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("PPV1")+"(kW)", dataIndex: "PPV1",  align: "right" },
                    { title: t("VPV1")+"(V)", dataIndex: "VPV1",  align: "right" },
                    { title: t("PPV2")+"(kW)", dataIndex: "PPV2",  align: "right" },
                    { title: t("VPV2")+"(V)", dataIndex: "VPV2",  align: "right" },
                ]}
                dataSource={rows}
            />),
            onOk() {
            },
        });
    };

    return (<svg xmlns="http://www.w3.org/2000/svg">
        <svg cursor={"pointer"} x={x} y={y} width={84} height={84}  viewBox="0 0 91.53 84.65"
            onClick={handleClick}
        >
            <SymbolAvgVoltage id="VoltageAvg"/>

            <defs>
                <style>{`.cls-1{fill:#1d80b5;}`}</style>
            </defs>
            <rect x="0" y="0" width="91.53" height="84.65" fill="#fff" stroke="none" />
            <g >
                <path className="cls-1" d="M82,10.56A1.28,1.28,0,0,0,83,10.24l1.82-1.68a1.18,1.18,0,0,0,0-1.67,1.3,1.3,0,0,0-1.73-.08L81.29,8.5A1.17,1.17,0,0,0,81,9.72a1.24,1.24,0,0,0,1,.84Zm5.62,11.13a1.08,1.08,0,0,0,.4,0l2.5-.33a1.24,1.24,0,0,0,1-1.37,1.25,1.25,0,0,0-1.4-1l-2.5.34a1.2,1.2,0,0,0-.05,2.39Zm.8,11.07-2.23-1.14a1.29,1.29,0,0,0-1.26,0,1.2,1.2,0,0,0,.07,2.1l2.23,1.14a1.3,1.3,0,0,0,1.71-.5,1.2,1.2,0,0,0-.52-1.64Zm-39-20-2.23-1.14a1.28,1.28,0,0,0-1.64.53A1.18,1.18,0,0,0,46,13.77l2.22,1.14a1.3,1.3,0,0,0,1.71-.5,1.2,1.2,0,0,0-.52-1.64Zm28,28a1.28,1.28,0,0,0-1.67-.52,1.18,1.18,0,0,0-.6,1.58L76.25,44a1.26,1.26,0,0,0,1,.73,1.28,1.28,0,0,0,1.16-.55,1.18,1.18,0,0,0,.06-1.24Zm-20.48-35A1.28,1.28,0,0,0,58,6.5,1.3,1.3,0,0,0,59.15,6a1.2,1.2,0,0,0,.06-1.24l-1.1-2.18A1.29,1.29,0,0,0,56.44,2a1.19,1.19,0,0,0-.6,1.59Zm13.66-1a1.25,1.25,0,0,0,.94-.2,1.2,1.2,0,0,0,.52-.78l.44-2.39a1.22,1.22,0,0,0-1-1.35A1.26,1.26,0,0,0,70,.94l-.44,2.39a1.17,1.17,0,0,0,.2,.91,1.33,1.33,0,0,0,.82.5Zm3,58.92L64.34,25.08a6.47,6.47,0,0,0-6.05-4.73H15.64a6.47,6.47,0,0,0-6.05,4.73L.31,63.66c-1.19,5,1.17,8.39,5.16,8.39h63c4,0,6.35-3.37,5.16-8.39Zm-4,3.87a2.79,2.79,0,0,1-2.27.92H6.6a2.79,2.79,0,0,1-2.27-.92c-.79-.93-1-2.54-.53-4.4l9-36.37a4,4,0,0,1,3.65-2.82H57.53a4,4,0,0,1,3.65,2.83l8.95,36.35c.45,1.87.26,3.48-.53,4.41Z" />
                <path className="cls-1" d="M33.12,25.84H18.52a4.08,4.08,0,0,0-3.89,3l-2.08,9.57a3,3,0,0,0,2.95,3.75H32.42a3.85,3.85,0,0,0,3.81-3.75l.1-9.57a3.07,3.07,0,0,0-3.21-3Z" />
                <path className="cls-1" d="M41.68,42.13H58.49a3,3,0,0,0,2.92-3.75l-2.07-9.57a4,4,0,0,0-3.86-3H41a3.05,3.05,0,0,0-3.18,3l.1,9.57a3.83,3.83,0,0,0,3.78,3.75Z" />
                <path className="cls-1" d="M32.35,43.37H15.18a5.2,5.2,0,0,0-4.71,4.12l-3,13.61c-.65,2.95.86,5.46,3.36,5.46H31.36c2.5,0,4.58-2.51,4.61-5.46l.15-13.61a3.92,3.92,0,0,0-3.77-4.12Z" />
                <path className="cls-1" d="M63.48,47.49a5.19,5.19,0,0,0-4.68-4.12h-17A3.9,3.9,0,0,0,38,47.49l.15,13.61c0,2.95,2.09,5.46,4.58,5.46H63.08c2.49,0,4-2.51,3.34-5.46Z" />
                <path className="cls-1" d="M47.21,79.31H40.08V76.64a2.66,2.66,0,0,0-1.39-2.31,2.84,2.84,0,0,0-2.77,0,2.66,2.66,0,0,0-1.39,2.31v2.67H27.39a2.52,2.52,0,0,0-2.57,2.47v.4a2.52,2.52,0,0,0,2.57,2.47H47.21a2.52,2.52,0,0,0,2.57-2.47v-.4a2.52,2.52,0,0,0-2.57-2.47Z" />
                <path className="cls-1" d="M67.18,6.27A17.6,17.6,0,0,0,50.44,17.88H61.2a6.46,6.46,0,0,1,6,4.73l4.13,17.15A17.13,17.13,0,0,0,84.84,23.27a16.69,16.69,0,0,0-5.17-12,18,18,0,0,0-12.49-5Z" />
                <rect className="cls-1" x="34.54" y="73.73" width="5.53" height="5.59" />
            </g>
            {/* ==================== */}
            {count > 1 ?
                <svg x ={84 - 32} y={84 - 32} width="32" height="32" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="46" stroke="#eee" strokeWidth="8" fill="#1d80b5" />
                    <text x="50" y="53" fontSize="46px" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">∑</text>
                </svg>
                : null
            }
        </svg>
        <svg x={x + 84 + 10} y={y + 10} >
            <text x={50} y={20} width={50} fontSize="20" fill="black" textAnchor="end">PV1</text>
            <text x={50 + 120} y={20} fontSize="20" fill="black" textAnchor="end">
                {PPV1} kW 
                {count>1 && <tspan dy="-1.2em" className='sigma'>(Σ{count})</tspan>}
            </text>
            <text x={50 + 120 + 76} y={20} fontSize="20" fill="black" textAnchor="end">{VPV1} {count<2 && "V"}</text>
            {count>1 && <use href="#VoltageAvg" x={50 + 120 + 76} y={0} fontSize="20" width="24" height="20" />}
            
            <text x={50} y={50} width={50} fontSize="20" fill="black" textAnchor="end">PV2</text>
            <text x={50 + 120} y={50} fontSize="20" fill="black" textAnchor="end">
                {PPV2} kW 
                {count>1 && <tspan dy="-1.2em" className='sigma'>(Σ{count})</tspan>}
            </text>
            <text x={50 + 120 + 76} y={50} fontSize="20" fill="black" textAnchor="end">{VPV2} {count<2 && "V"}</text>
            {count>1 && <use href="#VoltageAvg" x={50 + 120 + 76} y={30} fontSize="20" width="24" height="20" />}
        </svg>
    </svg>)
}

export default SvgPv